import { render, staticRenderFns } from "./VTabs.vue?vue&type=template&id=17e840ee"
import script from "./VTabs.vue?vue&type=script&lang=js"
export * from "./VTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports